import constConf from '../../../constconf'

export default {
    // fileBindAll: (context, botId) => {
    //     let url = constConf.message.url + '/file-bind/all/' + botId
    //     return context.dispatch('axios/query', { method: 'get', url: url }, { root: true })
    //         .then(response => {
    //             return response
    //         })
    // },
    fileBindAll: (context, payload) => {
        let url = constConf.message.url + '/file-bind/all/' + payload.model.bot_id
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: payload }, { root: true })
            .then(response => {
                return response
            })
    },
    fileAll: (context, botId) => {
        let url = constConf.message.url + '/file/all/' + botId
        return context.dispatch('axios/query', { method: 'get', url: url }, { root: true })
            .then(response => {
                return response
            })
    },
    createMediaBindForModel: (context, payload) => {
        let url = constConf.message.url + '/file-bind/update-for-model/' + payload.model.bot_id
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: payload }, { root: true })
            .then(response => {
                return response
            })
    },
    generateMainMessage: (context, payload) => {
        let url = constConf.message.url + '/message/generate-main-message/' + payload.botId + '?theme_id=' + payload.themeId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                return response
            })
    },
    generateProfileMessage: (context, payload) => {
        let url = constConf.message.url + '/message/generate-profile-message/' + payload.botId + '?theme_id=' + payload.themeId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                return response
            })
    }
}
